import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import noop from "lodash/noop";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { InternalSetWorkspaceModal, SYSADMIN_SET_WORKSPACE_MODAL_LOCAL_STORAGE_KEY } from "./SysadminSetWorkspaceModal";
import { addRecentlyUsedWorkspace } from "./utils/addRecentlyUsedWorkspace";
import { isAdminDotAirDotInc } from "./utils/isAdminDotAirDotInc";
const SYSADMIN_CONTEXT_DEFAULT_VALUE = {
    handleClearWorkspaceId: noop,
    handleSetWorkspaceId: noop,
    isInternal: false,
    workspaceId: undefined
};
export const SysadminContext = /*#__PURE__*/ createContext(SYSADMIN_CONTEXT_DEFAULT_VALUE);
export const SysadminProvider = (param)=>{
    let { children, onRedirectOnWorkspaceChange } = param;
    const [isInternal, setIsInternal] = useState(false);
    const [workspaceId, setWorkspaceId] = useState(undefined);
    useEffect(()=>{
        if (isAdminDotAirDotInc()) {
            const recentlyUsed = localStorage.getItem(SYSADMIN_SET_WORKSPACE_MODAL_LOCAL_STORAGE_KEY);
            const recentlyUsedArray = recentlyUsed ? JSON.parse(recentlyUsed) : [];
            if (recentlyUsedArray.length) {
                setWorkspaceId(recentlyUsedArray[0].id);
            }
            setIsInternal(true);
        }
    }, []);
    /**
   * Actions for setting the workspace id.
   */ const handleClearWorkspaceId = useCallback(()=>setWorkspaceId(undefined), []);
    const handleSetWorkspaceId = useCallback((workspaceId, redirect)=>{
        if (redirect && onRedirectOnWorkspaceChange) {
            onRedirectOnWorkspaceChange(workspaceId);
        }
        setWorkspaceId(workspaceId);
        addRecentlyUsedWorkspace(workspaceId);
    }, [
        onRedirectOnWorkspaceChange
    ]);
    const values = useMemo(()=>({
            handleClearWorkspaceId,
            handleSetWorkspaceId,
            isInternal,
            workspaceId
        }), [
        handleClearWorkspaceId,
        handleSetWorkspaceId,
        isInternal,
        workspaceId
    ]);
    return /*#__PURE__*/ _jsxs(SysadminContext.Provider, {
        value: values,
        children: [
            children,
            isInternal && !workspaceId && /*#__PURE__*/ _jsx(InternalSetWorkspaceModal, {})
        ]
    });
};
export function useSysadmin() {
    const context = useContext(SysadminContext);
    if (context === SYSADMIN_CONTEXT_DEFAULT_VALUE) {
        throw "useSysadmin must be used within a SysadminProvider";
    }
    return context;
}
